<template>
    <div class="full-screen-container container" ref="fullScreenContainer">
        <el-empty style="display: flex;align-items: center;height: 100vh;font-size: 28px;"
            v-if="!list || list.length == 0" description="暂无可显示的投屏">
            <template #image>
                <img src="@/assets/images/empty.png" alt="自定义图片" />
            </template>
        </el-empty>

        <div v-else class="main">
            <el-row class="title">
                <el-cell :span="8">请选择投屏：</el-cell>
                <el-cell :span="8"> </el-cell>
                <el-cell :span="8"> </el-cell>
            </el-row>
            <el-row class="mycontent">
                <el-cell :span="24">
                    <el-row>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[0])">
                                <div v-if="list[0]" :class="['bg-purple', list[0].type]">
                                    <div class="area">{{ list[0].Name }}</div>
                                    <!-- <div class="name">{{ list[0].Name }}</div> -->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[1])">
                                <div v-if="list[1]" :class="['bg-purple', list[1].type]">
                                    <div class="area">{{ list[1].Name }}</div>
                                    <!-- <div class="name">{{ list[1].Name }}</div> -->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[2])">
                                <div v-if="list[2]" :class="['bg-purple', list[2].type]">
                                    <div class="area">{{ list[2].Name }}</div>
                                    <!-- <div class="name">{{ list[2].Name }}</div> -->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[3])">
                                <div v-if="list[3]" :class="['bg-purple', list[3].type]">
                                    <div class="area">{{ list[3].Name }}</div>
                                    <!-- <div class="name">{{ list[3].Name }}</div> -->
                                </div>
                            </div>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[4])">
                                <div v-if="list[4]" :class="['bg-purple', list[4].type]">
                                    <div class="area">{{ list[4].Name }}</div>
                                    <!-- <div class="name">{{ list[4].Name }}</div></div>-->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[5])">
                                <div v-if="list[5]" :class="['bg-purple', list[5].type]">
                                    <div class="area">{{ list[5].Name }}</div>
                                    <!-- <div class="name">{{ list[5].Name }}</div></div>-->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[6])">
                                <div v-if="list[6]" :class="['bg-purple', list[6].type]">
                                    <div class="area">{{ list[6].Name }}</div>
                                    <!-- <div class="name">{{ list[6].Name }}</div></div>-->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[7])">
                                <div v-if="list[7]" :class="['bg-purple', list[7].type]">
                                    <div class="area">{{ list[7].Name }}</div>
                                    <!-- <div class="name">{{ list[7].Name }}</div></div>-->
                                </div>
                            </div>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[8])">
                                <div v-if="list[8]" :class="['bg-purple', list[8].type]">
                                    <div class="area">{{ list[8].Name }}</div>
                                    <!-- <div class="name">{{ list[8].Name }}</div></div>-->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[9])">
                                <div v-if="list[9]" :class="['bg-purple', list[9].type]">
                                    <div class="area">{{ list[9].Name }}</div>
                                    <!-- <div class="name">{{ list[9].Name }}</div></div>-->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[10])">
                                <div v-if="list[10]" :class="['bg-purple', list[10].type]">
                                    <div class="area">{{ list[10].Name }}</div>
                                    <!-- <div class="name">{{ list[10].Name }}</div>-->
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content" @click="goToRoute(list[11])">
                                <div v-if="list[11]" :class="['bg-purple', list[11].type]">
                                    <div class="area">{{ list[11].Name }}</div>
                                    <!-- <div class="name">{{ list[11].Name }}</div></div>-->
                                </div>
                            </div>
                        </el-col>

                    </el-row>
                </el-cell>

            </el-row>
            <el-row class="description">
                数据范围：实时销售监控、特价商品、业绩看板
            </el-row>
        </div>
    </div>
</template>

<script>
import { geusersmartscreen } from '@/api/salesummary.js';
export default {
    name: 'ViewSelect',
    props: {
        msg: String,
    },
    data() {
        return {
            keyTimeout: {},
            list: [],
            showList: [],
            pageIndex: 1,
            pageSize: 12,
            designWidth: 1920,
            screenScale: 1
        }
    },
    mounted() {
        this.setAppScale();
        window.addEventListener('resize', this.setAppScale);
        this.getScreen();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setAppScale);
    },
    methods: {
        setAppScale() {
            const dom = this.$refs.fullScreenContainer;
            if (!dom) return;
            const currentWidth = document.body.clientWidth;
            this.screenScale = currentWidth / this.designWidth;
            dom.style.transform = `scale(${this.screenScale})`;
            dom.style.transformOrigin = 'left top';
            dom.style.width = `${this.designWidth}px`;
            dom.style.height = `${(this.designWidth / currentWidth) * document.body.clientHeight}px`;
        },
        getScreen() {
            // 接口调用，获取数据列表，赋值给list，showList，pageIndex，pageSize等变量，
            // 用于展示数据列表和分页器。同时，需要处理接口返回的错误情况，例如显示错误提示等。 
            geusersmartscreen({}).then(res => {
                if (res.Code === 0) {
                    console.log('获取数据成功', res); // 处理成功逻辑，例如更新数据列表等操作
                    if (res.Data.Count === 1) {
                        this.goToRoute(res.Data.Data[0]);

                    } else {
                        this.list = res.Data.Data.map(item => {
                            return { ...item, type: item.TypeId === 1 ? 'operation' : (item.TypeId === 2 ? 'performance' : 'price') }
                        });
                    }
                }
            })
        },
        goToRoute(item) {
            // 这里根据 item 的信息决定跳转的路由
            // 假设我们根据 type 来决定跳转的路由
            let routeName = '';
            switch (item.TypeId) {
                case 1:
                    routeName = 'BranchSale'; // 替换为实际的路由名称
                    break;
                case 3:
                    routeName = 'ItemPromotion'; // 替换为实际的路由名称
                    break;
                case 2:
                    routeName = 'SalesPerformance'; // 替换为实际的路由名称
                    break;
                case 4:
                    routeName = 'CarouselView'; // 替换为实际的路由名称
                    break;
                default:
                    break;
            }
            if (routeName) {
                if (routeName === 'CarouselView') {
                    this.$router.push({ name: routeName, query: { SmartScreenId: item.Id, ModelId: item.ModelId || '1,2,3' } });

                } else {
                    this.$router.push({ name: routeName, query: { SmartScreenId: item.Id } });
                }
            }
        },
        handleKeydown(event) {
            clearTimeout(this.keyTimeout);
            this.keyTimeout = setTimeout(() => {
                // 处理按键事件
                switch (event.code) {
                    case 'ArrowUp':
                        console.log('上键被按下');
                        // 处理上键逻辑
                        break;
                    case 'ArrowDown':
                        console.log('下键被按下');
                        // 处理下键逻辑
                        break;
                    case 'ArrowLeft':
                        console.log('左键被按下');
                        // 处理左键逻辑
                        break;
                    case 'ArrowRight':
                        console.log('右键被按下');
                        // 处理右键逻辑
                        break;
                    case 'Enter':
                        console.log('确认键被按下');
                        // 处理确认键逻辑
                        break;
                    // 可以根据需要添加更多按键的处理
                    default:
                        break;
                }
            }, 100);
        }
    }
}
</script>

<style scoped>
.full-screen-container {
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
}

.container {
    opacity: 0.9;
    background: #000000;
    backdrop-filter: blur(10px);
}

.container .main {
    margin: 100px;
}

.container .main .title {
    color: #FFF;
    text-align: left;
    font-size: 32px;
    font-family: 阿里巴巴普惠体 2.0, 阿里巴巴普惠体 2.0-85 Bold;
}

.mycontent {
    min-height: 680px;
    color: #ffffff;
    border: 1px solid #aaa9a9;
    border-radius: 16px;
    padding: 28px;

}

.description {
    font-size: 24px;
    font-family: 阿里巴巴普惠体 2.0, 阿里巴巴普惠体 2.0-55 Regular;
    font-weight: 55 Regular;
    text-align: left;
    color: #ffffff;
}

.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.grid-content {
    width: 100%;
    min-height: 100px;
    max-height: 200px;
}

.bg-purple {
    height: 200px;
    background-size: contain;
    background-position: center;
    /* 图片居中显示 */
    background-repeat: no-repeat;
    /* 不重复 */

    text-align: left;
    font-family: 阿里巴巴普惠体 2.0, 阿里巴巴普惠体 2.0-85 Bold;
    font-weight: bold;
    color: #ffffff;
}

.bg-purple .area {
    font-size: 32px;
    padding-left: 58px;
    padding-top: 28px;
}

.bg-purple .name {
    font-size: 24px;
    padding-left: 58px;
    padding-top: 8px;

}

.price {

    background-image: url('/src/assets/images/price.png');
}

.operation {

    background-image: url('/src/assets/images/operation.png');
}

.performance {

    background-image: url('/src/assets/images/performance.png');
}
</style>